<template>
	<transition name="fadeIn">
		<div class="page page-rating">
			<ul class="grid-lines-wrapper">
				<li class="grid-line line-0"></li>
				<li class="grid-line line-1"></li>
				<li class="grid-line line-2"></li>
				<li class="grid-line line-3"></li>
				<li class="grid-line line-4"></li>
				<li class="grid-line line-5"></li>
			</ul>
			<div class="page-content">
				<div class="text-wrapper">
					<h1 class="title">РЕЙТИНГ</h1>
				</div>
			</div>
			<ul class="weeks-list" :class="{collapse: showInnerWeek}">
				<li class="weeks-item"
					v-for="item in weeks"
					:class="{active: item.id <= currentWeek,current: item.id === currentWeek}">
					<a @click.prevent="showWeek($event,`/rating/${item.id}`)" v-if="item.id <= currentWeek" class="item-content item-link">
						<div class="item-wrapper">
							<h3 class="text" v-html="item.name"></h3>
							<div class="line"></div>
						</div>
					</a>
					<div v-else class="item-content">
						<div class="item-wrapper">
							<h3 class="text" v-html="item.name"></h3>
							<div class="line"></div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</transition>
</template>

<script>
	import {TweenMax} from 'gsap';
	import Helpers from '@/tools/Helpers'

	const weeks = [
		{
			name: 'первая <br>неделя',
			id: 1,
		},
		{
			name: 'вторая <br>неделя',
			id: 2,
		},
		{
			name: 'третья <br>неделя',
			id: 3,
		},
		{
			name: 'четвертая <br>неделя',
			id: 4,
		},
		{
			name: 'пятая <br>неделя',
			id: 5,
		}
	];
	export default {
		name: 'Rating',
		data() {
			return {
				weeks,
				Helpers,
				showInnerWeek: false
			}
		},
		computed: {
			currentWeek() {
				return this.$store.getters['getCurrentWeek'];
			},

		},
		components: {
			Helpers
		},
		mounted() {
			this.Helpers.ga().send('load', 'Страница рейтинга общего');
			this.$store.commit('UPD_UI_SHOW', true);
		},
		methods: {
			showWeek(e, path) {
				this.$router.push(path)

//				if(Helpers.isMobile() ){
//					this.$router.push(path)
//				}else {
//					let parent = e.currentTarget.parentNode;
//					parent.classList.add('actived');
//					this.showInnerWeek = true;
//					setTimeout(() => {
//						this.$router.push(path)
//					},1500)
//				}

			}
		}
	}

</script>




// WEBPACK FOOTER //
// Rating.vue?7ccba0ae